var cov_1sz05pl4h4 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Gap/index.tsx",
      hash = "acb158d70537de9a229bbb4095aa289a609626f2",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Gap/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 23
        },
        end: {
          line: 7,
          column: 32
        }
      },
      "1": {
        start: {
          line: 8,
          column: 21
        },
        end: {
          line: 11,
          column: 1
        }
      },
      "2": {
        start: {
          line: 18,
          column: 35
        },
        end: {
          line: 18,
          column: 45
        }
      },
      "3": {
        start: {
          line: 19,
          column: 24
        },
        end: {
          line: 19,
          column: 108
        }
      },
      "4": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 48
        }
      },
      "5": {
        start: {
          line: 24,
          column: 49
        },
        end: {
          line: 24,
          column: 59
        }
      },
      "6": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 40
        }
      },
      "7": {
        start: {
          line: 25,
          column: 24
        },
        end: {
          line: 25,
          column: 40
        }
      },
      "8": {
        start: {
          line: 26,
          column: 19
        },
        end: {
          line: 26,
          column: 63
        }
      },
      "9": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 98
        }
      },
      "10": {
        start: {
          line: 31,
          column: 25
        },
        end: {
          line: 31,
          column: 35
        }
      },
      "11": {
        start: {
          line: 32,
          column: 22
        },
        end: {
          line: 32,
          column: 69
        }
      },
      "12": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 46,
          column: 5
        }
      },
      "13": {
        start: {
          line: 39,
          column: 12
        },
        end: {
          line: 43,
          column: 13
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        },
        loc: {
          start: {
            line: 17,
            column: 13
          },
          end: {
            line: 21,
            column: 3
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        },
        loc: {
          start: {
            line: 23,
            column: 30
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 23
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        },
        loc: {
          start: {
            line: 30,
            column: 11
          },
          end: {
            line: 47,
            column: 3
          }
        },
        line: 30
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 38,
            column: 10
          },
          end: {
            line: 38,
            column: 11
          }
        },
        loc: {
          start: {
            line: 39,
            column: 12
          },
          end: {
            line: 43,
            column: 13
          }
        },
        line: 39
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 19,
            column: 24
          },
          end: {
            line: 19,
            column: 108
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 19,
            column: 41
          },
          end: {
            line: 19,
            column: 75
          }
        }, {
          start: {
            line: 19,
            column: 78
          },
          end: {
            line: 19,
            column: 108
          }
        }],
        line: 19
      },
      "1": {
        loc: {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 25,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 25,
            column: 40
          }
        }, {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 25,
            column: 40
          }
        }],
        line: 25
      },
      "2": {
        loc: {
          start: {
            line: 27,
            column: 63
          },
          end: {
            line: 27,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 27,
            column: 63
          },
          end: {
            line: 27,
            column: 70
          }
        }, {
          start: {
            line: 27,
            column: 74
          },
          end: {
            line: 27,
            column: 97
          }
        }],
        line: 27
      },
      "3": {
        loc: {
          start: {
            line: 39,
            column: 12
          },
          end: {
            line: 43,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 39,
            column: 12
          },
          end: {
            line: 39,
            column: 17
          }
        }, {
          start: {
            line: 40,
            column: 14
          },
          end: {
            line: 42,
            column: 20
          }
        }],
        line: 39
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Gap/index.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { gapClass } from './styles';
import support from './support';
var flexGapSupport = (cov_1sz05pl4h4.s[0]++, support());
var DefaultProps = (cov_1sz05pl4h4.s[1]++, {
  row: 8,
  column: 8
});

var Gap =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Gap, _PureComponent);

  var _super = _createSuper2(Gap);

  function Gap() {
    _classCallCheck(this, Gap);

    return _super.apply(this, arguments);
  }

  _createClass(Gap, [{
    key: "getStyle",
    value: function getStyle() {
      cov_1sz05pl4h4.f[0]++;

      var _ref = (cov_1sz05pl4h4.s[2]++, this.props),
          row = _ref.row,
          column = _ref.column,
          style = _ref.style;

      var extendStyle = (cov_1sz05pl4h4.s[3]++, flexGapSupport ? (cov_1sz05pl4h4.b[0][0]++, {
        rowGap: row,
        columnGap: column
      }) : (cov_1sz05pl4h4.b[0][1]++, {
        marginBottom: -Number(row)
      }));
      cov_1sz05pl4h4.s[4]++;
      return Object.assign({}, style, extendStyle);
    }
  }, {
    key: "getItemStyle",
    value: function getItemStyle(index) {
      cov_1sz05pl4h4.f[1]++;

      var _ref2 = (cov_1sz05pl4h4.s[5]++, this.props),
          row = _ref2.row,
          column = _ref2.column,
          itemStyle = _ref2.itemStyle,
          children = _ref2.children;

      cov_1sz05pl4h4.s[6]++;

      if (flexGapSupport) {
        cov_1sz05pl4h4.b[1][0]++;
        cov_1sz05pl4h4.s[7]++;
        return itemStyle;
      } else {
        cov_1sz05pl4h4.b[1][1]++;
      }

      var isLast = (cov_1sz05pl4h4.s[8]++, React.Children.count(children) - 1 === index);
      cov_1sz05pl4h4.s[9]++;
      return Object.assign({}, itemStyle, {
        marginBottom: row
      }, (cov_1sz05pl4h4.b[2][0]++, !isLast) && (cov_1sz05pl4h4.b[2][1]++, {
        marginRight: column
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      cov_1sz05pl4h4.f[2]++;

      var _ref3 = (cov_1sz05pl4h4.s[10]++, this.props),
          children = _ref3.children;

      var className = (cov_1sz05pl4h4.s[11]++, classnames(gapClass('_'), this.props.className));
      cov_1sz05pl4h4.s[12]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          style: this.getStyle(),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 35,
            columnNumber: 7
          }
        }, React.Children.map(children, function (child, index) {
          cov_1sz05pl4h4.f[3]++;
          cov_1sz05pl4h4.s[13]++;
          return (cov_1sz05pl4h4.b[3][0]++, child) && (cov_1sz05pl4h4.b[3][1]++,
          /*#__PURE__*/
          React.createElement("div", {
            className: gapClass('item'),
            style: _this.getItemStyle(index),
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 40,
              columnNumber: 15
            }
          }, child));
        }))
      );
    }
  }]);

  return Gap;
}(PureComponent);

Gap.defaultProps = DefaultProps;
export default Gap;